var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isLoading
    ? _c(
        "div",
        { attrs: { id: "sample-detail" } },
        [
          _c(
            "b-breadcrumb",
            [
              _c("b-breadcrumb-item", {
                attrs: { text: "Samples", to: "/samples" }
              }),
              _vm._v(" "),
              _c("b-breadcrumb-item", {
                attrs: {
                  text: "" + _vm.sample.labSampleReference,
                  active: true
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-card",
            { attrs: { "header-tag": "header", "header-class": "no-border" } },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "h2",
                  [
                    _c("font-awesome-icon", {
                      staticClass: "icon",
                      attrs: { icon: "vials" }
                    }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.sample.labSampleReference) +
                        "\n      "
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.job && _vm.job.priority.toLowerCase().trim() == "urgent"
                  ? _c(
                      "span",
                      { staticClass: "urgent-flag" },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "icon",
                          attrs: { icon: "flag", "fixed-width": "" }
                        }),
                        _vm._v("Urgent\n      ")
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "job-status d-flex align-items-center" },
                [
                  _vm.job
                    ? _c(
                        "div",
                        {
                          staticClass: "badge badge-lg",
                          class:
                            "badge-" +
                            _vm.job.status
                              .toLowerCase()
                              .trim()
                              .replace(/ /g, "-")
                        },
                        [_vm._v(_vm._s(_vm.job.status))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "label" }, [_vm._v("Priority")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.job.priority))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("Job Reference")
                      ]),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { attrs: { tag: "a", to: "/jobs/" + _vm.job.jobId } },
                        [
                          _c(
                            "strong",
                            [
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.job.labRegistrationReference))
                              ]),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "icon",
                                attrs: {
                                  icon: "angle-right",
                                  "fixed-width": ""
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Sample Date")
                    ]),
                    _vm._v(" "),
                    _vm.sample.sampleDate
                      ? _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("moment")(
                                _vm.sample.sampleDate,
                                "D MMM YYYY"
                              )
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.sample.sampleDate
                      ? _c("span", { staticClass: "value" }, [_vm._v("-")])
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "col-border-right" }, [
                    _c("dl", [
                      _c("dt", [_vm._v("Client Reference")]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.job.clientRegistrationReference || "-")
                        )
                      ]),
                      _vm._v(" "),
                      _c("dt", [_vm._v("Client")]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.job.client.name))]),
                      _vm._v(" "),
                      _c("dt", [_vm._v("Contact")]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.job.client.firstName) +
                            " " +
                            _vm._s(_vm.job.client.lastName)
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "col-border-right" }, [
                    _c("dl", [
                      _vm.showField("matrix")
                        ? _c("dt", [_vm._v("Matrix")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showField("matrix")
                        ? _c("dd", [_vm._v(_vm._s(_vm.sample.matrix || "-"))])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("dt", [_vm._v("Sample Condition")]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.sample.sampleCondition || "-"))
                      ]),
                      _vm._v(" "),
                      _vm.showField("samplingDepth")
                        ? _c("dt", [_vm._v("Sampling Depth")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showField("samplingDepth")
                        ? _c("dd", [
                            _vm._v(_vm._s(_vm.sample.samplingDepth || "-"))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showField("samplesInComposite")
                        ? _c("dt", [_vm._v("Samples in Composite")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showField("samplesInComposite")
                        ? _c("dd", [
                            _vm._v(_vm._s(_vm.sample.samplesInComposite || "-"))
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c("dl", [
                      _c("dt", [_vm._v("Composite Reference")]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.sample.compositeReference || "-"))
                      ]),
                      _vm._v(" "),
                      _vm.showField("batchReference")
                        ? _c("dt", [_vm._v("Batch Reference")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showField("batchReference")
                        ? _c("dd", [
                            _vm._v(_vm._s(_vm.sample.batchReference || "-"))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showField("cowNumber")
                        ? _c("dt", [_vm._v("Cow Number")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showField("cowNumber")
                        ? _c("dd", [
                            _vm._v(_vm._s(_vm.sample.cowNumber || "-"))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showField("factoryId")
                        ? _c("dt", [_vm._v("Factory ID")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showField("factoryId")
                        ? _c("dd", [
                            _vm._v(_vm._s(_vm.sample.factoryId || "-"))
                          ])
                        : _vm._e()
                    ])
                  ])
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-tabs",
            { staticClass: "mt-4" },
            [
              _c(
                "b-tab",
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "icon",
                        attrs: { icon: "chart-pie" }
                      }),
                      _vm._v("Results\n      ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("ResultsTable", {
                    staticClass: "mt-4",
                    attrs: { jobId: _vm.getJobId, sampleId: _vm.getSampleId }
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7354e14b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7354e14b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SampleDetail.vue
// module id = 75Nu
// module chunks = 1